import { useCallback } from 'react';
import { useLocation } from 'react-router';
import { GridApi } from 'ag-grid-community';
import { CompanyColId } from './useKPICompaniesAllColDefs';

export function useAssignedFilter() {
  const companyFilter = useLocation().state?.companyName;

  const setGridFilter = useCallback(
    (gridApi: GridApi | null) => {
      if (!gridApi || !companyFilter) {
        return;
      }
      void gridApi.setColumnFilterModel(CompanyColId, { values: [companyFilter] });
    },
    [companyFilter]
  );

  return { setGridFilter };
}
